module.exports = __webpack_public_path__ + "assets/images/icon_intro_repair.d40ba4b.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/business-model/intro/icon_intro_repair.svg
// module id = 926
// module chunks = 2